import { Component } from '@angular/core';
import { TranslateModule } from '../../shareds/translate/translate.module';

@Component({
  selector: 'app-room-quantity',
  imports: [TranslateModule],
  templateUrl: './room-quantity.component.html',
  styleUrls: ['./room-quantity.component.css']
})
export class RoomQuantityComponent {

}
